module.exports = __webpack_public_path__ + "static/flux-hifi-2-340bc2faff10ada28959942e78e640fe.png";